if (!customElements.get('quiz-weight-slider')) {
  class QuizWeightSlider extends HTMLElement {
    constructor() {
      super();
      this.rangeInput = null;
      this.numberInput = null;
      this.fill = null;
      this.thumb = null;
      this.track = null;
      this.dogs = [];
      this.trackResizeObserver = null;
    }

    connectedCallback() {
      this.rangeInput = this.querySelector('[data-slider-range]');
      this.numberInput = this.querySelector('input[type="number"]');
      this.fill = this.querySelector('[data-slider-fill]');
      this.thumb = this.querySelector('[data-slider-thumb]');
      this.track = this.querySelector('[data-slider-track]');
      this.dogs = [...this.querySelectorAll('picture')];

      this.onRangeInput = this.onRangeInput.bind(this);
      this.onNumberInput = this.onNumberInput.bind(this);
      this.onNumberChange = this.onNumberChange.bind(this);
      this.onNumberFocus = this.onNumberFocus.bind(this);

      this.rangeInput.addEventListener('input', this.onRangeInput);
      this.numberInput.addEventListener('input', this.onNumberInput);
      this.numberInput.addEventListener('change', this.onNumberChange);
      this.numberInput.addEventListener('focus', this.onNumberFocus);

      this.trackResizeObserver = new ResizeObserver(() => {
        if (this.track.offsetWidth > 0) {
          this.updateUI();
        }
      });
      this.trackResizeObserver.observe(this.track);
    }

    disconnectedCallback() {
      this.rangeInput.removeEventListener('input', this.onRangeInput);
      this.numberInput.removeEventListener('input', this.onNumberInput);
      this.numberInput.removeEventListener('change', this.onNumberChange);
      this.numberInput.removeEventListener('focus', this.onNumberFocus);
      if (this.trackResizeObserver) this.trackResizeObserver.disconnect();
    }

    onRangeInput() {
      this.numberInput.value = this.rangeInput.value;
      this.updateUI();
    }

    onNumberInput() {
      const raw = parseInt(this.numberInput.value);
      if (!isNaN(raw)) {
        const min = parseInt(this.rangeInput.min);
        const max = parseInt(this.rangeInput.max);
        const clamped = Math.min(Math.max(raw, min), max);
        this.rangeInput.value = clamped;
        this.updateUI();
      }
    }

    onNumberChange() {
      const min = parseInt(this.rangeInput.min);
      const max = parseInt(this.rangeInput.max);
      let val = parseInt(this.numberInput.value);
      if (isNaN(val)) val = min;
      val = Math.min(Math.max(val, min), max);
      this.numberInput.value = val;
      this.rangeInput.value = val;
      this.updateUI();
    }

    onNumberFocus() {
      this.numberInput.select();
    }

    updateUI() {
      const min = parseInt(this.rangeInput.min);
      const max = parseInt(this.rangeInput.max);
      const val = parseInt(this.rangeInput.value);
      const percent = (val - min) / (max - min);

      const trackRect = this.track.getBoundingClientRect();
      const trackWidth = trackRect.width;
      const thumbWidth = this.thumb.offsetWidth;
      const thumbLeft = percent * (trackWidth - thumbWidth);

      // px required: values derived from getBoundingClientRect() pixel measurements
      this.thumb.style.left = `${thumbLeft}px`;
      this.fill.style.width = `${percent * trackWidth}px`;

      const thumbCenterX = trackRect.left + thumbLeft + thumbWidth / 2;

      let activeIndex = -1;
      if (percent === 0) {
        activeIndex = 0;
      } else if (percent === 1) {
        activeIndex = this.dogs.length - 1;
      } else {
        let closestDistance = Infinity;
        this.dogs.forEach((picture, i) => {
          const rect = picture.getBoundingClientRect();
          const pictureCenterX = rect.left + rect.width / 2;
          const distance = Math.abs(thumbCenterX - pictureCenterX);
          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = i;
          }
        });
      }

      this.dogs.forEach((picture, i) => {
        picture.classList.toggle('quiz__weight-dog--active', i === activeIndex);
      });
    }
  }

  customElements.define('quiz-weight-slider', QuizWeightSlider);
}
